import { FeedbackData } from '../components/FeedbackModal';
import { apiCall } from './authApi';

export interface SubmitFeedbackRequest {
  type: 'bug' | 'feature' | 'general';
  title: string;
  description: string;
  userEmail: string;
  userName: string;
  contextInfo: {
    currentMode: string;
    userAgent: string;
    url: string;
    timestamp: string;
  };
}

export interface SubmitFeedbackResponse {
  success: boolean;
  message: string;
}

export const submitFeedback = async (feedback: FeedbackData): Promise<SubmitFeedbackResponse> => {
  const response = await apiCall('/feedback/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(feedback),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Failed to submit feedback' }));
    throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
  }

  return await response.json();
};